import { useShowPriceInVat } from "hooks";
import { createFormHelper } from "lib/Form";
import { GeneralInfoForm } from "modules/AppointmentDetails/components/Interventions/components/GeneralInfo/components";
import "modules/AppointmentDetails/components/Interventions/components/GeneralInfo/GeneralInfo.scss";
import { useAppointmentLocation, useUpdateInterventionMutation } from "modules/AppointmentDetails/hooks";
import { getInterventionPriceWithVAT, getPriceWithoutVat } from "utils/common";

import type { DropdownItemProps } from "components";
import type { Appointment, Intervention, PIN_TYPES } from "models";
import type { INTERVENTION_TABS } from "modules/AppointmentDetails/components/Interventions/components";
import type { GeneralInfoFormValues } from "modules/AppointmentDetails/components/Interventions/components/GeneralInfo/components";

type GeneralInfoProps = {
  intervention: Intervention;
  appointment: Appointment | null;
  onPinTypeSet: (pinTypeID: PIN_TYPES | null) => void;
  pinTypeOptions: DropdownItemProps<PIN_TYPES>[];
  typeID: PIN_TYPES | null;
  handleTabSelection: (tab: INTERVENTION_TABS) => void;
  onSetHasChanges: (hasChanges: boolean) => void;
};

const FormHelper = createFormHelper<GeneralInfoFormValues>();

export const GeneralInfo = ({ intervention, appointment, onPinTypeSet, typeID, pinTypeOptions, onSetHasChanges, handleTabSelection }: GeneralInfoProps) => {
  const { mutateAsync: updateIntervention } = useUpdateInterventionMutation();

  const selectedLocation = useAppointmentLocation();
  const showPriceInVat = useShowPriceInVat();

  return (
    <div className="GeneralInfo">
      <FormHelper.Form
        defaultValues={{
          title: intervention.title,
          description: intervention.description,
          price: showPriceInVat ? getInterventionPriceWithVAT(intervention, selectedLocation) : intervention.price,
          customer_ok: intervention.customer_ok
        }}
        onSubmit={values => {
          if (!values.title) return;

          return updateIntervention({
            ...values,
            price: showPriceInVat ? getPriceWithoutVat(values.price, selectedLocation, intervention.vat) : values.price,
            appointment_id: intervention.appointment_id,
            dms_nr: intervention.dms_nr,
            id: intervention.id,
            visible_to_customer: intervention.visible_to_customer
          });
        }}
      >
        <GeneralInfoForm
          intervention={intervention}
          appointment={appointment}
          onPinTypeSet={onPinTypeSet}
          typeID={typeID}
          pinTypeOptions={pinTypeOptions}
          onSetHasChanges={onSetHasChanges}
          handleTabSelection={handleTabSelection}
        />
      </FormHelper.Form>
    </div>
  );
};
